import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams, limitGetListParam } from "../utils/fetch/PrepareBaseGetListParams";
import { prepareEnumSearchParams } from "../utils/fetch/PrepareEnumSearchParams";


export const EventService = {
    getEvents: (criteria, enums) => {
        console.log('EventService::getList-criteria', criteria);
        const params = prepareBaseGetListParams(criteria);
        prepareEnumSearchParams(criteria.baseQuery, params, enums);
        if (criteria.statuses) {
            limitGetListParam(params, 'statuses', criteria.statuses);
        }
        if (criteria.period) {
            params.append('period', criteria.period);
        }
        return fetchWithAuth(`/portal/events?${params.toString()}`, { method: 'GET' });
    },
    getDeviceEvents: (deviceId, criteria) => {
        console.log('EventService::getList-criteria', criteria);
        const params = prepareBaseGetListParams(criteria);
        if (criteria.statuses) {
            limitGetListParam(params, 'statuses', criteria.statuses);
        }
        return fetchWithAuth(`/portal/events/device/${deviceId}?${params.toString()}`, { method: 'GET' });
    },
    getEventTypeList: () => {
        return fetchWithAuth(`/portal/events/type-list`, { method: 'GET' });
    },
    getEventPriorityList: () => {
        return fetchWithAuth(`/portal/events/priority-list`, { method: 'GET' });
    },
    getEventStatusList: () => {
        return fetchWithAuth(`/portal/events/status-list`, { method: 'GET' });
    },
    getTechnicianList: () => {
        return fetchWithAuth(`/portal/events/technician-list`, { method: 'GET' });
    },
    getActiveNotificationCount: (deviceId) => {
        return fetchWithAuth(`/portal/events/device/${deviceId}/active-notification-count`, { method: 'GET' });
    },
    getEventsWithoutRoute: (criteria) => {
        console.log('EventService::getEventsWithoutRoute-criteria', criteria);
        const params = prepareBaseGetListParams(criteria);
        if (criteria.statuses) {
            limitGetListParam(params, 'statuses', criteria.statuses);
        }
        return fetchWithAuth(`/portal/events/without-route?${params.toString()}`, { method: 'GET' });
    },
    closeEvent: (eventExternalId, comment) => {
        const payload = comment ? { comment } : {};
        return fetchWithAuth(`/portal/events/${eventExternalId}/close`, {
            method: 'PUT',
            body: Object.keys(payload).length > 0 ? JSON.stringify(payload) : undefined
        });
    },
    closeMultipleEvents: (eventExternalIds, comment, selectedAll = false, filters = {}, selectionExceptions = []) => {
        const payload = {
            eventExternalIds: selectedAll ? [] : eventExternalIds,
            selectedAll
        };
        
        if (comment) {
            payload.comment = comment;
        }
        
        if (selectedAll && selectionExceptions && selectionExceptions.length > 0) {
            payload.selectionExceptions = selectionExceptions;
        }
        
        if (selectedAll && filters) {
            if (filters.search) payload.search = filters.search;
            if (filters.eventDateTimeFrom) payload.eventDateTimeFrom = filters.eventDateTimeFrom;
            if (filters.eventDateTimeTo) payload.eventDateTimeTo = filters.eventDateTimeTo;
            if (filters.eventTypes && filters.eventTypes.length > 0) payload.eventTypes = filters.eventTypes;
            if (filters.deviceName) payload.deviceName = filters.deviceName;
            if (filters.systemId) payload.systemId = filters.systemId;
            if (filters.devices && filters.devices.length > 0) payload.devices = filters.devices;
            if (filters.locations && filters.locations.length > 0) payload.locations = filters.locations;
            if (filters.priorities && filters.priorities.length > 0) payload.priorities = filters.priorities;
        }
        
        return fetchWithAuth(`/portal/events/close-multiple`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        });
    },
    appointTechnician: (eventExternalId, technicianId, scheduledDate, options = {}) => {
        const payload = {
            technicianId,
            scheduledDate,
            mergeRoutes: Boolean(options.mergeRoutes),
            reassignEvents: Boolean(options.reassignEvents),
            extractEvent: Boolean(options.extractEvent)
        };
        return fetchWithAuth(`/portal/events/${eventExternalId}/assign-technician`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        });
    },
    assignMultipleEventsToTechnician: (technicianId, scheduledDate, eventExternalIds, selectedAll = false, filters = {}, options = {}, selectionExceptions = []) => {
        const payload = {
            technicianId,
            scheduledDate,
            eventExternalIds: selectedAll ? [] : eventExternalIds,
            selectedAll,
            mergeRoutes: Boolean(options.mergeRoutes),
            reassignEvents: Boolean(options.reassignEvents)
        };
        
        if (selectedAll && selectionExceptions && selectionExceptions.length > 0) {
            payload.selectionExceptions = selectionExceptions;
        }
        
        if (selectedAll && filters) {
            if (filters.search) payload.search = filters.search;
            if (filters.eventDateTimeFrom) payload.eventDateTimeFrom = filters.eventDateTimeFrom;
            if (filters.eventDateTimeTo) payload.eventDateTimeTo = filters.eventDateTimeTo;
            if (filters.eventTypes && filters.eventTypes.length > 0) payload.eventTypes = filters.eventTypes;
            if (filters.deviceName) payload.deviceName = filters.deviceName;
            if (filters.systemId) payload.systemId = filters.systemId;
            if (filters.devices && filters.devices.length > 0) payload.devices = filters.devices;
            if (filters.locations && filters.locations.length > 0) payload.locations = filters.locations;
            if (filters.priorities && filters.priorities.length > 0) payload.priorities = filters.priorities;
        }
        
        return fetchWithAuth(`/portal/events/assign-multiple-technician`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        });
    }
}